<template>
  <v-card class="ml-2 mr-3 mb-3">
    <v-container class="pa-0">
      <v-toolbar card dense>
        <v-toolbar-side-icon>
          <v-chip :color="dispatchSpread <= 0 ? 'red' : 'green'" text-color="white" small>
            ${{ dispatchSpread }}
          </v-chip>
        </v-toolbar-side-icon>

        <v-toolbar-title :class="isDispatchActive(dispatch) ? '' : 'font-weight-light font-italic'">ID: {{ dispatch.humanId }}</v-toolbar-title>
        <v-spacer/>
        <v-icon v-if="isDispatchActive(dispatch)"
                color="accent"
                @click="cancelDispatchRequest(dispatch)">
          cancel
        </v-icon>
        <v-icon v-else disabled>highlight_off</v-icon>

      </v-toolbar>

      <v-list>
        <v-list-tile>
          <v-list-tile-action>
            <v-chip color="primary" text-color="white" small>
              <v-icon>send</v-icon>
            </v-chip>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ dispatch.createdByDisplayName }}</v-list-tile-title>
            <v-list-tile-sub-title>{{ dispatch.created | formatDate }}</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="!isDispatchActive(dispatch)">
          <v-list-tile-action>
            <v-chip color="primary" text-color="white" small>
              <v-icon>highlight_off</v-icon>
            </v-chip>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ dispatch.retractedByDisplayName }}</v-list-tile-title>
            <v-list-tile-sub-title>{{ dispatch.retracted | formatDate }}</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-action>
            <v-chip color="primary" text-color="white" small>
              <v-icon v-if="includeCustomer">person_add</v-icon>
              <v-icon v-else>person_add_disabled</v-icon>
            </V-chip>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Customer <span v-if="!includeCustomer">not</span> included</v-list-tile-title>
            <v-list-tile-sub-title>on the Load Details and {{ $t('terms.bill-of-lading') }}</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-action>
            <v-chip color="primary" text-color="white" small>
              <v-icon>monetization_on</v-icon>
            </v-chip>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Pays ${{ dispatch.payableAmount }}</v-list-tile-title>
            <v-list-tile-sub-title v-if="billableAmount">Bills ${{ billableAmount }}</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      <template v-if="specificDispatchRecipients">
        <v-list-tile>
          <v-list-tile-action>
            <v-chip color="primary" text-color="white" small>
              <v-icon>share</v-icon>
            </v-chip>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Dispatch Recipients</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          <v-card class="ml-5" >
            <div class="pl-2"
                 v-for="invited in specificDispatchRecipients" :key="invited.id">
              {{ invited.companyName }}
            </div>
          </v-card>
        </v-list-tile>
      </template>
        <template v-else>
          <v-list-tile>
            <v-list-tile-action>
              <v-chip color="primary" text-color="white" small>
                <v-icon>share</v-icon>
              </v-chip>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Dispatch Recipients</v-list-tile-title>
              <v-list-tile-sub-title>ALL members of your Preferred Carriers</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
        <v-list-tile>
          <v-list-tile-action>
            <v-chip color="primary" text-color="white" small>
              <v-icon>visibility</v-icon>
            </v-chip>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              {{ dispatchRequestVisibleCount(dispatch) }} visible
              {{ dispatchRequestVisibleCount(dispatch) | pluralize('load', { includeNumber: false }) }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile v-if="dispatchFollowers"
                     :key="follower + idx"
                     v-for="(follower, idx) in dispatchFollowers">
          <v-list-tile-action>
            <v-chip color="primary" text-color="white" small v-if="idx==0">
              <v-icon>notifications_active</v-icon>
            </v-chip>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ follower.name }}</v-list-tile-title>
            <v-list-tile-sub-title>{{ follower.companyNames }}</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-container>
  </v-card>
</template>

<script>
import _ from 'lodash';
import Vue2Filters from 'vue2-filters';
import * as types from '@/store/mutationTypes';
import API from '@/api';
import loadGroupMixin from '@/mixins/loadGroupMixin';
import dispatchRequestsMixin from '@/mixins/dispatchRequestsMixin';

export default {
  name: 'VDispatchRequest',
  mixins: [
    dispatchRequestsMixin,
    loadGroupMixin,
    Vue2Filters.mixin,
  ],
  props: {
    dispatch: {
      type: Object,
      required: true,
    },
    load: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    loadingBtn: false,
  }),
  computed: {
    _() {
      return _;
    },
    dispatchSpread() {
      return this.load.loadGroup.amount - this.dispatch.payableAmount;
    },
    includeCustomer() {
      return _.get(this.dispatch, 'dispatcher.includeCustomer', false);
    },
    billableAmount() {
      return _.get(this.load, 'loadGroup.amount', null);
    },
    specificDispatchRecipients() {
      if (this.dispatch.dispatcher.preferredCarriers && this.dispatch.dispatcher.preferredCarriers.length) {
        return this.dispatch.dispatcher.preferredCarriers;
      }
      return null;
    },
    dispatchFollowers() {
      return this.dispatch.following;
    },
  },
  methods: {
    isDispatchActive(dispatch) {
      return !(dispatch.status === 'CANCELED');
    },
    async cancelDispatchRequest(dispatch) {
      const confirmation = await this.$confirm(`Do you really want to cancel dispatch request ${dispatch.humanId}?`);
      if (!confirmation) {
        return;
      }

      this.loadingBtn = true;
      try {
        this.$store.commit(`applications/${types.START_LOADING}`);

        await API.planner.cancelDispatch({
          loadId: this.load.humanId,
          dispatchId: dispatch.humanId,
        });

        this.$store.dispatch('applications/setSuccessNotification', {
          message: 'Dispatch Request Canceled',
          timeout: 4000,
        });

        this.$emit('refreshLoad');
      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: error.message,
        });
      } finally {
        this.loadingBtn = false;
        this.$store.commit(`applications/${types.END_LOADING}`);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Companies/Loads/components/DispatchRequest.vue